import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, Card, Button, Radio, message } from "antd";
import { ajax } from "../utils/request";
import { useSearchParams } from "react-router-dom";
import "./sub.css";

// Plans identiques à la modale Pricing (pas de fichier commun)
const PLANS_LOCAL = {
  essential: {
    title: "Essential Access",
    subtitle: "Individual Access Plan",
    price: 50,
    features: ["Full access to all CiviBOT features", "30-day free trial"],
  },
  growth: {
    title: "Growth Access",
    subtitle: "11-50 employees",
    price: 30,
    features: [
      "Full access to all CiviBOT features",
      "30-day free trial",
      "Onboarding and Training",
    ],
  },
  enterprise: {
    title: "Enterprise Suite",
    subtitle: "51+ employees",
    price: 20,
    features: [
      "Full access to all CiviBOT features",
      "30-day free trial",
      "Onboarding and Training",
      "Custom Features",
    ],
  },
};

export default function Subscribe({ isLoggedIn, setLoginOpen, setAccountOpen, setPricingOpen, setFaqOpen }) {
  const [messageApi, contextHolder] = message.useMessage();
  const { confirm } = Modal;
  const { t, i18n } = useTranslation();

  const clickLogin = () => setLoginOpen(true);
  const changeLanguage = () => {
    if (i18n.language === "en") i18n.changeLanguage("fr");
    else i18n.changeLanguage("en");
  };

  // plan sélectionné
  const [searchParams] = useSearchParams();
  const planId = (searchParams.get("plan") || "growth").toLowerCase();
  const plan = PLANS_LOCAL[planId] || PLANS_LOCAL.growth;
  const [count] = React.useState(1);
  const [userData, setUserData] = React.useState(null);

  const showConfirm = () => {
    confirm({
      title: t("book.tipTitle"),
      content: t("book.tipContent"),
      onOk() {
        window.location.href = "/";
      },
      onCancel() {
        window.location.href = "/";
      },
    });
  };

  const handleSubscribe = () => {
    ajax.get(`/user/book/${count}`).then((res) => {
      let { code } = res.data;
      if (code === 0) {
        messageApi.open({
          type: "success",
          content: t("book.success"),
          duration: 3,
        });
      } else {
        messageApi.open({
          type: "error",
          content: t("book.failed"),
          duration: 3,
        });
      }
    });
  };

  React.useEffect(() => {
    if (isLoggedIn) {
      ajax.get(`/user/me`).then((res) => {
        let { data } = res.data;
        setUserData(data);
      });
    } else {
      showConfirm();
    }
  }, [isLoggedIn, showConfirm]);

  const total = (count * plan.price).toFixed(2);

  return (
    <div className="w-full flex flex-col items-center bg-[#f5f5f7] overflow-y-auto"
      style={{ minHeight: 'calc(100vh - 50px)' }}>
      {contextHolder}

      {/* Contenu abonnement */}
      <div className="md:max-w-[980px] flex flex-col md:flex-row w-full text-[16px] px-[6px] flex-grow">
        {/* Colonne gauche */}
        <div className="subscribe-info w-full md:w-1/2 min-h-[60vh] flex flex-col md:pr-[65px] pt-[60px]">
          <div className="text-[hsla(0,0%,10%,.6)]">{t("book.text1")}</div>

          <div className="price flex flex-row items-center mt-[.5em]">
            <div className="digtal text-[36px] font-bold">
              ${plan.price.toFixed(2)}
            </div>
            <div className="text pl-[10px] text-[18px] text-[hsla(0,0%,10%,.6)]">
              {t("book.text2")}
            </div>
          </div>

          <div className="plan text-[15px] mt-[40px]">
            <div className="flex flex-row justify-between">
              <div className="">{`CiviBot Pro - ${plan.title}`}</div>
              <div className="">{`$${plan.price.toFixed(2)}`}</div>
            </div>
            {plan.subtitle && (
              <div className="text-[hsla(0,0%,10%,.6)] mt-1">{plan.subtitle}</div>
            )}
          </div>

          <div className="flex flex-row justify-between text-[16px] items-center">
            <div className="text-[hsla(0,0%,10%,.6)]">{t("book.text3")}</div>
          </div>

          <div className="count flex flex-row justify-between text-[16px] mt-[50px]">
            <div className="">{t("book.text5")}</div>
            <div className="">{`$ ${total}`}</div>
          </div>
        </div>

        {/* Colonne droite */}
        <div className="pay w-full md:w-1/2 h-full md:pl-[65px] pt-[60px] flex flex-col ">
          <div className="pb-[16px] text-[hsla(0,0%,10%,.6)] text-[18px]">
            {t("book.contact")}
          </div>
          <div className="email py-[8px] px-[5px] rounded-lg flex flex-row items-center">
            <span className="text-[#1a1a1ab2]">Email:</span>
            <span className="pl-[25px] text-[hsla(0,0%,10%,.9)] text-[14px]">
              {userData && userData.email}
            </span>
          </div>

          {/* Carte alignée prix/features comme Pricing */}
          <Card title={plan.title} className="card mt-[30px]">
            <ul className="px-[22px]">
              <li className="mb-[15px]" style={{ listStyleType: "none" }}>
                <span className="font-bold text-[24px]">{`$${plan.price.toFixed(
                  2
                )}`}</span>{" "}
                /mo
                {plan.subtitle && (
                  <>
                    <br />
                    <span className="font-bold" style={{ color: "blue" }}>
                      {plan.subtitle}
                    </span>
                  </>
                )}
              </li>
              {plan.features.map((f, i) => (
                <li key={i}>
                  <span className="font-bold">{f}</span>
                </li>
              ))}
            </ul>
          </Card>

          <div className="agree my-[20px]">
            <Radio>
              {t("book.a1")}
              <a href="/privacy-policy.html" className="u px-[2px] underline">
                {t("book.a4")}
              </a>
              {t("book.a3")}
              <a href="/tos.html" className="u underline px-[2px]">
                {t("book.a2")}
              </a>{" "}
            </Radio>
          </div>

          <div className="confirm">
            <Button
              type="primary"
              className="w-full h-[35px] mt-[10px] mb-[30px] font-bold"
              onClick={handleSubscribe}
            >
              {t("book.subscribe")}
            </Button>
          </div>

          <div className="text">{t("book.tip2")}</div>
        </div>
      </div>

      
      <div className="container flex flex-col items-center w-full max-w-[936px] px-[6px] mt-auto">
        <div className="footer w-full mt-[auto] pt-[26px] cursor-pointer flex flex-row items-center justify-center text-[14px]">
          {isLoggedIn ? (
            <div
              className="item px-[3px] text-[#969699] hover:text-[var(--blue-text)]"
              onClick={() => {
                setAccountOpen(true);
              }}
            >
              {t("home.footer_text1")}
            </div>
          ) : (
            <div
              className="item px-[3px] text-[#969699] hover:text-[var(--blue-text)]"
              onClick={clickLogin}
            >
              {t("home.footer_text2")}
            </div>
          )}

          <div className="item px-[3px] text-[#969699] hover:text-[var(--blue-text)]">
            {" "}
            -{" "}
          </div>
          <div
            className="item px-[3px] text-[#969699] hover:text-[var(--blue-text)]"
            onClick={() => {
              setPricingOpen(true);
            }}
          >
            {t("home.footer_text3")}
          </div>
          <div className="item px-[3px] text-[#969699] hover:text-[var(--blue-text)]">
            {" "}
            -{" "}
          </div>
          <div
            className="item px-[3px] text-[#969699] hover:text-[var(--blue-text)]"
            onClick={() => {
              setFaqOpen(true);
            }}
          >
            {t("home.faq")}
          </div>

          <div className="item px-[3px] text-[#969699] hover:text-[var(--blue-text)]">
            {" "}
            -{" "}
          </div>
          <div
            className="item px-[3px] text-[#969699] hover:text-[var(--blue-text)]"
            onClick={() => {
              window.open("https://www.linkedin.com/company/civibot");
            }}
          >
            {t("home.footer_text4")}
          </div>
          <div className="item px-[3px] text-[#969699] hover:text-[var(--blue-text)]">
            {" "}
            -{" "}
          </div>
          <div
            className="item px-[3px] text-[#969699] hover:text-[var(--blue-text)]"
            onClick={changeLanguage}
          >
            {t("selectLang")}
          </div>
        </div>
        <div className="footer desc w-full text-center text-[#969696] text-[14px]">
          {t("footer")}
        </div>
      </div>
      
    </div>
  );
}
